/* Ported from the approved prototype. The cart is Shopify's, so the
   localStorage bag is gone; everything else is the same code that was
   signed off, not a rewrite of it. */
(function(){
(function(){
  var b=document.querySelector('.burger'), m=document.querySelector('.mnav');
  if(!b||!m) return;
  b.addEventListener('click',function(){
    var open=m.hasAttribute('hidden');
    if(open){m.removeAttribute('hidden');}else{m.setAttribute('hidden','');}
    b.setAttribute('aria-expanded',String(open));
    b.classList.toggle('is-open',open);
    document.body.classList.toggle('nav-open',open);
  });
})();})();
(function(){
(function(){
  /* Own the animation rather than relying on native smooth scrolling, which
     behaves inconsistently across browsers and cannot be measured reliably
     in automated checks. This is deterministic and testable. */
  function ends(rail){
    var wrap=rail.closest('.railwrap'); if(!wrap) return;
    var sec=rail.closest('.sec');
    var l=sec&&sec.querySelector('.narw--l'), r=sec&&sec.querySelector('.narw--r');
    var max=rail.scrollWidth-rail.clientWidth;
    if(l) l.hidden = rail.scrollLeft <= 4;
    if(r) r.hidden = max <= 4 || rail.scrollLeft >= max-4;
  }
  function step(rail){
    var t=rail.querySelector('.t,.art');
    return t ? Math.round(t.getBoundingClientRect().width+26)*2 : 480;
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function glide(rail,to){
    var from=rail.scrollLeft, d=to-from, t0=null, ms=420;
    if(reduce || !window.requestAnimationFrame){ rail.scrollLeft=to; ends(rail); return; }
    function frame(ts){
      if(t0===null) t0=ts;
      var k=Math.min(1,(ts-t0)/ms);
      var e=1-Math.pow(1-k,3);              /* ease-out cubic */
      rail.scrollLeft=from+d*e;
      if(k<1) requestAnimationFrame(frame); else ends(rail);
    }
    requestAnimationFrame(frame);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('.narw'); if(!b) return;
    e.preventDefault();
    var rail=document.getElementById('rail-'+b.getAttribute('data-rail'));
    if(!rail) return;
    var dir=parseInt(b.getAttribute('data-dir'),10);
    var max=rail.scrollWidth-rail.clientWidth;
    glide(rail, Math.max(0,Math.min(max, rail.scrollLeft+dir*step(rail))));
  });
  function wire(){
    document.querySelectorAll('.rail').forEach(function(r){
      ends(r);
      r.addEventListener('scroll',function(){ends(r);},{passive:true});
    });
  }
  window.addEventListener('resize',wire);
  if(document.readyState!=='loading') wire(); else document.addEventListener('DOMContentLoaded',wire);
  window.addEventListener('load',wire);
})();})();

(function(){
  /* ---- collection controls ------------------------------------------------
     Category chips, deck width, size and sort are plain links now: Shopify
     filters and sorts the whole collection on the server, across every page
     (snippets/collection-controls.liquid). The sort menu is a <details>, so it
     opens without script; this only closes it on an outside click or Escape and
     lets the arrow keys move between its options. */
  function sortwrap(){ return document.querySelector('details.sortwrap'); }
  function closeSort(){ var d = sortwrap(); if(d && d.open) d.open = false; }

  document.addEventListener('click', function(e){
    if(!e.target.closest('.sortwrap')) closeSort();
  });

  document.addEventListener('toggle', function(e){
    var d = e.target;
    if(!d.matches || !d.matches('details.sortwrap') || !d.open) return;
    var cur = d.querySelector('.sortmenu a[aria-current="true"]') || d.querySelector('.sortmenu a');
    if(cur) cur.focus();
  }, true);

  document.addEventListener('keydown', function(e){
    var d = sortwrap(); if(!d || !d.open) return;
    var opts = [].slice.call(d.querySelectorAll('.sortmenu a'));
    var i = opts.indexOf(document.activeElement);
    if(e.key==='Escape'){ e.preventDefault(); d.open = false; d.querySelector('summary').focus(); }
    else if(e.key==='ArrowDown'){ e.preventDefault(); (opts[i+1]||opts[0]).focus(); }
    else if(e.key==='ArrowUp'){ e.preventDefault(); (opts[i-1]||opts[opts.length-1]).focus(); }
  });

  /* Everything on the page that looks clickable should be clickable.
     Variant chips, image thumbnails and category filters were all inert. */

  // --- product image thumbnails -------------------------------------------
  document.addEventListener('click', function(e){
    var th = e.target.closest('.thumbs img'); if(!th) return;
    var main = document.querySelector('.pdp__main img'); if(!main) return;
    // the main photo has a size set (main-product); swap the set with the photo, or the browser keeps the old one
    var set = th.getAttribute('data-srcset');
    if (set) main.srcset = set; else main.removeAttribute('srcset');
    main.src = th.getAttribute('data-full') || th.src;
    th.parentNode.querySelectorAll('img').forEach(function(i){ i.classList.remove('is-on'); });
    th.classList.add('is-on');
  });

  // --- quantity, share, store information ----------------------------------
  document.addEventListener('click', function(e){
    var q = e.target.closest('.qty__b');
    if(q){
      var i = q.closest('.qty__c').querySelector('.qty__i');
      var n = Math.min(99, Math.max(1, (parseInt(i.value,10)||1) + (+q.getAttribute('data-step'))));
      i.value = n; return;
    }
    var m = e.target.closest('.pickup__more');
    if(m){
      var d = m.parentNode.querySelector('.pickup__d');
      d.hidden = !d.hidden;
      m.setAttribute('aria-expanded', d.hidden ? 'false' : 'true');
      m.textContent = d.hidden ? 'View store information' : 'Hide store information';
      return;
    }
    var sh = e.target.closest('[data-share]');
    if(sh){
      var url = location.href, ttl = document.title;
      /* Web Share on a phone, clipboard everywhere else. Both are real - no
         third-party share widget phoning home from a product page. */
      if(navigator.share){ navigator.share({title:ttl, url:url}).catch(function(){}); }
      else if(navigator.clipboard){
        navigator.clipboard.writeText(url).then(function(){
          var s2 = sh.querySelector('span'), old = s2.textContent;
          s2.textContent = 'Link copied'; sh.classList.add('is-ok');
          setTimeout(function(){ s2.textContent = old; sh.classList.remove('is-ok'); }, 1600);
        });
      }
      return;
    }
  });

  // --- variant chips -------------------------------------------------------
  /* A chip press reads the chosen value of EVERY option row, finds the variant with exactly those values
     (#variantData) and makes the whole page agree with it: the hidden id the form sends, the price (and
     was-price), the add-to-bag button (Sold out / Unavailable when that combination can't be bought), SKU,
     availability line, the address (?variant=, so a shared or reloaded link keeps the choice) and the photo
     when that variant has its own. Until 8 Oct 2026 a press only restyled the chip, so the bag always got the
     first variant. Liquid renders the chosen variant (?variant= or the first available) already pressed. */
  (function(){
    var form = document.getElementById('buyform'), idIn = document.getElementById('variantId');
    var dataEl = document.getElementById('variantData');
    if(!form || !idIn || !dataEl || !form.querySelector('.chips')) return;
    var variants = []; try { variants = JSON.parse(dataEl.textContent) || []; } catch(err) { return; }
    var view = {}; try { view = JSON.parse((document.getElementById('variantView') || {}).textContent || '{}'); } catch(err) {}
    var rows = [].slice.call(form.querySelectorAll('.chips[data-opt]'));
    function chosen(){
      return rows.map(function(r){ var on = r.querySelector('.chip[aria-pressed="true"]'); return on ? on.getAttribute('data-value') : null; });
    }
    function match(vals){
      for(var i=0;i<variants.length;i++){
        var v = variants[i], ok = true;
        for(var k=0;k<vals.length;k++){ if(v.options[k] !== vals[k]){ ok = false; break; } }
        if(ok) return v;
      }
      return null;
    }
    // marks values that can't be bought together with the other current choices (same look as a sold-out chip,
    // still pressable, so any in-stock combination can be reached)
    function markRows(vals){
      rows.forEach(function(r, k){
        r.querySelectorAll('.chip').forEach(function(c){
          if(c.disabled) return;
          var test = vals.slice(); test[k] = c.getAttribute('data-value');
          var v = match(test);
          c.classList.toggle('is-unavail', !(v && v.available));
        });
      });
    }
    function setText(el, t){ if(el && el.textContent !== t) el.textContent = t; }
    function apply(fromClick){
      var vals = chosen(), v = match(vals);
      var btn = document.getElementById('pdpAdd') || form.querySelector('button[type=submit]');
      markRows(vals);
      if(btn){
        btn.disabled = !(v && v.available);
        setText(btn, v ? (v.available ? (btn.getAttribute('data-add') || 'Add to bag') : (btn.getAttribute('data-soldout') || 'Sold out')) : (btn.getAttribute('data-unavailable') || 'Unavailable'));
      }
      if(!v) return;
      if(idIn.value !== String(v.id)){ idIn.value = v.id; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
      var vw = view[v.id] || {}, price = document.getElementById('pdpPrice');
      if(price && vw.price){
        var html = vw.was ? '<span class="was"></span>\n          <span class="now"></span>' : '';
        if(vw.was){ price.innerHTML = html; price.querySelector('.was').textContent = vw.was; price.querySelector('.now').textContent = vw.price; }
        else setText(price, vw.price);
      }
      var sku = document.getElementById('pdpSku'), skuL = document.getElementById('pdpSkuL');
      if(sku){ setText(sku, v.sku || ''); sku.hidden = !v.sku; if(skuL) skuL.hidden = !v.sku; }
      var av = document.getElementById('pdpAvail');
      if(av && av.hasAttribute('data-in')) setText(av, v.available ? av.getAttribute('data-in') : av.getAttribute('data-out'));
      if(fromClick){
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch(err) {}
        var main = document.querySelector('.pdp__main img');
        if(main && vw.img){
          var th = document.querySelector('.thumbs img[data-image-id="' + vw.imgId + '"]');
          if(vw.set) main.srcset = vw.set; else main.removeAttribute('srcset');
          main.src = vw.img;
          if(th){ th.parentNode.querySelectorAll('img').forEach(function(i){ i.classList.remove('is-on'); }); th.classList.add('is-on'); }
        }
      }
    }
    form.addEventListener('click', function(e){
      var c = e.target.closest('.chip'); if(!c || c.disabled) return;
      var box = c.closest('.chips');
      box.querySelectorAll('.chip').forEach(function(b){ b.setAttribute('aria-pressed','false'); b.classList.remove('is-on'); });
      c.setAttribute('aria-pressed','true'); c.classList.add('is-on');
      apply(true);
    });
    apply(false);
  })();

  /* The category filter lives in UI_JS with the width/size refine, so that one
     function decides visibility. Two handlers used to run on the same click -
     this one synchronously via style.display, the other a tick later via
     .hidden - which cost a second layout pass (the flicker) and let an inline
     display:none outrank the [hidden] rule, so the two could disagree. */
})();

(function () {
  'use strict';
  function lock(){ var b=document.documentElement.clientWidth;
    document.body.classList.add('locked');
    var p=document.documentElement.clientWidth-b;
    if(p>0) document.documentElement.style.paddingRight=p+'px'; }
  function unlock(){ document.documentElement.style.paddingRight='';
    document.body.classList.remove('locked'); }
  function open_(s){ var e=document.querySelector(s); if(e){ e.hidden=false; lock(); } }
  function shut(s){ var e=document.querySelector(s); if(e){ e.hidden=true; unlock(); } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.hd__search')) { e.preventDefault(); open_('.srch');
      var i=document.querySelector('.srch__in'); if(i) i.focus(); return; }
    if (e.target.closest('.srch__x') || e.target.classList.contains('srch')) { shut('.srch'); return; }
    if (e.target.closest('.cart__x') || e.target.classList.contains('cart')) { shut('.cart'); return; }

    var q = e.target.closest('.qty__b');
    if (q) { var i2=q.closest('.qty__c').querySelector('.qty__i');
      i2.value = Math.min(99, Math.max(1,(parseInt(i2.value,10)||1)+(+q.getAttribute('data-step'))));
      return; }

    var pm = e.target.closest('.pickup__more');
    if (pm) { var d=pm.parentNode.querySelector('.pickup__d');
      d.hidden=!d.hidden; pm.setAttribute('aria-expanded', d.hidden?'false':'true');
      pm.textContent = d.hidden ? 'View store information' : 'Hide store information';
      return; }

    var sh = e.target.closest('[data-share]');
    if (sh) {
      if (navigator.share) { navigator.share({title:document.title,url:location.href}).catch(function(){}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(location.href).then(function(){
          var s=sh.querySelector('span'), old=s.textContent;
          s.textContent='Link copied'; sh.classList.add('is-ok');
          setTimeout(function(){ s.textContent=old; sh.classList.remove('is-ok'); },1600);
        });
      }
      return;
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape'){ shut('.cart'); shut('.srch'); }
  });
})();

/* ---- review marquee -------------------------------------------------------
   Duration comes from the measured track width, so the cards travel at a
   constant pixels-per-second whatever the review count. Re-measured on resize
   and once webfonts land, because both change the width. */
(function () {
  var track = document.getElementById('revTrack');
  if (!track) return;
  var PX_PER_SEC = 42;
  function pace() {
    var half = track.scrollWidth / 2;
    if (!half) return;
    track.style.setProperty('--belt', (half / PX_PER_SEC) + 's');
  }
  pace();
  addEventListener('resize', pace);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pace);
  track.classList.add('belt');
})();

/* ---- mobile nav groups ----------------------------------------------------
   Only the chevron toggles; the label itself stays a working link so a tap on
   "Skateboards" still goes to the hub. */
document.addEventListener('click', function (e) {
  var t = e.target.closest('.mg__t');
  if (!t) return;
  e.preventDefault();
  var sub = document.getElementById(t.getAttribute('aria-controls'));
  if (!sub) return;
  var open = sub.hidden;
  sub.hidden = !open;
  t.setAttribute('aria-expanded', open ? 'true' : 'false');
});

/* Second product photo (shown on hover). Only devices that can hover load it, and only for cards near the
   screen or under the pointer, so phones never download it. The card swaps photos once it has loaded. */
(function(){
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function ready(card){
    var b = card.querySelector('img.b[data-srcset]'); if (!b) return;
    b.addEventListener('load', function(){ card.classList.add('is-b'); }, { once: true });
    b.srcset = b.getAttribute('data-srcset'); b.removeAttribute('data-srcset');
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { io.unobserve(e.target); ready(e.target); } });
    }, { rootMargin: '300px' });
    document.querySelectorAll('a.t').forEach(function(c){ io.observe(c); });
  }
  document.addEventListener('pointerover', function(e){
    var c = e.target.closest && e.target.closest('a.t'); if (c) ready(c);
  });
})();
